import React from 'react';
import { useParams } from 'react-router-dom';

let data = {};
function HookRoute({ load, children }) {
    let params = useParams();
    if (data !== params) {
        data = params;
        load(data);
    }

    return <div>{children}</div>;
}

export default HookRoute;
